<template >
<div name="unitfilelist">

                    <div
                      class="
                        absolute
                        top-0
                        w-4
                        h-4
                        origin-center
                        transform
                        rotate-45
                        translate-x-5
                        -translate-y-2
                        bg-white
                        border-t border-l border-gray-200
                        rounded-sm
                        pointer-events-none
                        ml-48
                      "
                    ></div>
                    <div class=" h-screen max-h-screen overflow-y-auto mb-10 pb-10">
                     
            <table class="w-full table-wrapper mb-6">
              <th colspan="2" class="text-left bg-gray-100 p-2 text-gray-500  ">{{title}} </th>
              <tbody >
                <tr v-for="item in filesList" :key="item.identifier" @click="displayResource(item)" 
                class="hover:bg-opacity-50 cursor-pointer"
                 
                >
                  <td class="w-10/12">
                    <span class="pl-2">
                      <i class="icon fas mr-2" v-bind:class="showIcon(item)"></i>
                    {{item.title}}
                    </span>
                   </td>
                  <td class="w-1/12 px-6 text-sm text-action-blue" >
                    View
                  </td>
                </tr>
              </tbody>
            </table>
                    
               
                  </div>
  

       <modalfile
      :url="getSelectedDocumentPath()"
      :title="selectedDocument.title"
      :format="selectedDocument.format"
      @close="closeModal()"
      v-if="selectedDocument != undefined && showModalFile"
      v-show="showModalFile"
    ></modalfile>
</div>

</template>

<script>
const modalfile = () => import("@/components/ModalFile.vue");
import { SchoolService } from "@/services/school.service";

export default {
  name: "unitfilelist",
  props: {
    course: Object,
    lesson: Object,
  },
  computed: {
    hasLessonFiles() {
      if (this.files === undefined) { return false }
      return this.files.length > 0
    },
    filesList() {
      var filesInView = this.files
      return _.orderBy(filesInView, ["display_order", "title"]); 
    },
    title() {
      if (this.lesson != undefined) {
        return this.lesson.name + " Files"
      } else {
        return "Unit General"
      }
    }
  },
  data: function () {
    return {
      selectedDocument: {},
      showModalFile: false,
      files: []
    };
  },
  created() {
    if (this.lesson != undefined) {
        this.fetchLessonResources();
    } else {
       this.fetchUnitResources();
    }
  },
  methods: {
    fetchUnitResources() {
      SchoolService.getAll("courses/" + this.course.id + "/resources")
        .then((response) => (this.files = response.data.data))
        .catch((err) => {
          console.log("Resources " + err);
          this.errored = true;
        });
    },
     fetchLessonResources() {
     
      SchoolService.getAll("lessons/" + this.lesson.id + "/resources")
        .then((response) => this.buildResourceList(response.data.data))
        .catch((err) => {
          console.log(" resources" + err);
          this.errored = true;
        })
        .finally(() => (this.errored = false));
    },
    buildResourceList(data) {
      this.files = data.filter(function (r) {
        return r.format != "diagram";
      });
      if (
        this.course.category.key_value != "concept" &&
        (this.lesson.document_url != null || this.lesson.document_url != "") &&
        ["file", "fields"].includes(this.lesson.layout)
      ) {
        const document = {
          format: "teaching",
          title: this.lesson.name + " session",
          url: this.lesson.document_url,
          display_order: 1,
        };
        this.files.push(document);
        console.log(JSON.stringify(this.files))
      }
      
    },
    cancelSelect() {
      this.$emit('close')
    },   
    displayResource(document) {
      this.selectedDocument = document;
      this.showModalFile = true;
    },
    getSelectedDocumentPath() {
      const formats = ['diagram', 'teaching']
      if (this.selectedDocument.folder === 'general' || formats.includes(this.selectedDocument.format)) {
         return this.selectedDocument.url;
      } else {
         return this.selectedDocument.folder + "/" + this.selectedDocument.url;
      }
    },
    showIcon(document) {
      let fileExt = document.url .split(".").pop();
      if (fileExt == "doc") {
        return "fa-file-word";
      } else if (fileExt == "pdf") {
        return "fa-file-pdf";
      } else if (["png", "jpg", "gif"].includes(fileExt)) {
        return "fa-file-image";
      } else if (fileExt == "csv") {
        return "fa-file-csv";
      } else if (["xls", "xlsx"].includes(fileExt)) {
        return "fa-file-exel";
      } else {
        return "fa-file-video";
      }
    },
    closeModal() {
      this.showModalFile = false
      this.cancelSelect()
    }
  },
  components: {
    modalfile
  },
};
</script>

<style scoped>

.table-wrapper tbody tr:last-child {
  border: 0 !important;
}
</style>
